
/**
 * Safely formats a price value ensuring it's a valid number
 * @param value Price value to format (number or string)
 * @param decimals Number of decimal places (default: 2)
 * @param inCents Whether the value is in cents and should be divided by 100 (default: false)
 * @returns Formatted price string with specified decimal places
 */
export const formatPrice = (
  value: number | string | undefined | null,
  decimals: number = 2,
  inCents: boolean = false
): string => {
  if (value === undefined || value === null) return "0.00";
  
  // Convert to number if it's a string
  const numeric = typeof value === "number" ? value : Number(value);
  
  // Check for NaN
  if (isNaN(numeric)) {
    console.error("[formatPrice] Invalid price value:", { value, type: typeof value });
    return "0.00";
  }
  
  // Apply cents conversion if needed
  const finalValue = inCents ? numeric / 100 : numeric;
  
  return finalValue.toFixed(decimals);
};

/**
 * Formats number values with comma separators
 * @param value Number to format
 * @returns Formatted number with comma separators
 */
export const formatNumber = (value: number | string | undefined | null): string => {
  if (value === undefined || value === null) return "0";
  
  const numeric = typeof value === "number" ? value : Number(value);
  
  if (isNaN(numeric)) {
    console.error("[formatNumber] Invalid numeric value:", { value, type: typeof value });
    return "0";
  }
  
  return numeric.toLocaleString('en-US');
};
